import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { TreeNavigationConfiguration } from '@ispm-client/modules/process-executor/models';
import { selectBpmnProcessState } from '@ispm-client/modules/process-executor/store/selectors/bpmn-process-state.selector';
import {NodeSelectionMode} from "@ispm-client/modules/process-executor/models/tree-navigation-configuration";

const getTreeNavigationConf = (state: State): any => state.treeNavigationConf;

export const selectTreeNavigationConf: MemoizedSelector<object, TreeNavigationConfiguration> =
  createSelector(selectBpmnProcessState, getTreeNavigationConf);

const getNodeSelectionMode = (treeNavigationConf: TreeNavigationConfiguration): any => treeNavigationConf ? treeNavigationConf.nodeSelectionMode : NodeSelectionMode.anyNode;

export const selectNodeSelectionMode: MemoizedSelector<object, NodeSelectionMode> =
  createSelector(selectTreeNavigationConf, getNodeSelectionMode);
